import { toIpynb } from "~/notebook/core/ipynb";
import { type Notebook } from "~/notebook/model/model";

export function blankNotebookFile(displayName: string): File {
  const fileName = displayName.endsWith(".ipynb") ? displayName : `${displayName}.ipynb`;
  const baseName = fileName.replace(/\.ipynb$/i, "");
  const intro = [
    `# ${baseName}`,
    "",
    "Cells run Python in your browser. Three Istari SDK clients are already initialized in every cell — no imports needed:",
    "",
    "- `istari` — resources, systems, jobs",
    "- `istari_admin` — users, tokens, connections (SCS), tenants, usage",
    "- `istari_integration` — agents, modules, tools, functions",
    "",
    "```python",
    "# list resources, then read one",
    "for r in istari.resources.list(size=5).items:",
    "    print(r.resource_id)",
    "",
    'doc = istari.resources.get("<resource_id>")',
    "print(doc.read_text())  # or .read_bytes() / .read_json()",
    "```",
    "",
    "**Link a resource:** use the **+ Add** menu on a cell to link a file or subsystem — it becomes a variable bound to `istari.resources.get(...)`, so you can call `.read_text()` on it directly.",
    "",
    "**Tip:** press ⌘G in a code cell to generate Python from a description.",
  ].join("\n");
  const blank: Notebook = {
    resourceId: "",
    displayName: fileName,
    extension: "ipynb",
    revisionLabel: "v1",
    cells: [
      {
        id: `cell-${crypto.randomUUID()}`,
        kind: "markdown",
        source: intro,
        links: [],
      },
    ],
    createdAt: new Date().toISOString(),
  };
  const json = JSON.stringify(toIpynb(blank), null, 1);
  return new File([json], fileName, { type: "application/x-ipynb+json" });
}
